module.exports = __webpack_public_path__ + "img/DK82112219.18d4aae4.png";